import { Navigate, Outlet, useLocation } from "react-router-dom";
import AdminSideBar from "./adminSidebar";
import { useSelector } from "react-redux";
import secureLocalStorage from "react-secure-storage";
import useBillingStatus from "../../hooks/useBillingStatus";

const environment = process.env.REACT_APP_ENVIRONMENT;
const BILLING_LOCK_PATH = "/zed_ecommerce/billing";

const PrivateRoutes = () => {
  let { isLoggedIn } = useSelector((store) => store.user);
  if (environment === "local") {
    isLoggedIn = true;
  }
  const group = secureLocalStorage.getItem("group");
  const { pathname } = useLocation();
  const { billingStatus, enforced, loaded } = useBillingStatus();
  // Subscription expired: admins can still log in and reach the dashboard shell,
  // but every page redirects to the billing page until they renew via Zed.
  const billingLocked = loaded && enforced && (billingStatus === 'Expired' || billingStatus === 'Inactive');

  return (
    <>
      {isLoggedIn ? (
        <>
          {group === "admin" ? (
            <AdminSideBar>
              {billingLocked && pathname !== BILLING_LOCK_PATH ? (
                <Navigate to={BILLING_LOCK_PATH} replace />
              ) : (
                <Outlet />
              )}
            </AdminSideBar>
          ) : (
            <Navigate to="/login" />
          )}
        </>
      ) : (
        <Navigate to="/zed_ecommerce/admin/login" />
      )}
    </>
  );
};

export default PrivateRoutes;
